export const COMPARE_BY_DIMENSIONS = [
  "agent",
  "mutation",
  "persona",
  "test_case",
  "metadata",
  "run",
  "tag",
  "custom",
] as const

export type CompareByDimension = (typeof COMPARE_BY_DIMENSIONS)[number]

export const COMPARE_BY_OPTION = {
  NONE: "none",
} as const

export const COMPARE_BY_OPTIONS = [
  COMPARE_BY_OPTION.NONE,
  ...COMPARE_BY_DIMENSIONS,
] as const

export type CompareByOption = (typeof COMPARE_BY_OPTIONS)[number]
